module.exports = __webpack_public_path__ + "img/ty_1.d03c4b9b.png";